import { checkClaimsWeb } from '@eventr/common'
import { useShallow } from 'zustand/react/shallow'
import { isConnectivityAvailable } from '../../feat/connectivity/connectivityListener'
import { bs, useBoundStore } from '../../state/bound.store'
import { homeTabSignal } from '../../state/itineraryState/itinerarySignals'
import { useRouteGuardContext } from '../../state/routeGuardProvider'
import { BottomPageFab } from '../components/bottomFab'
import { Paths } from '../../routes'
import { useGlobalRouter } from '../../feat/globalRouter/useGlobalRouter'

export const ButtonsAndArrowsDisplayedHome = () => {
    const { pushPath } = useGlobalRouter()
    const { noItineraries, past, selectedItinEmpty } = useBoundStore(
        useShallow((s) => {
            return {
                noItineraries: s.noItineraries,
                past: s.past,
                selectedItinEmpty: s.selectedItinEmpty,
            }
        })
    )
    const { isAllowed } = useRouteGuardContext()

    if (homeTabSignal.value === 'map') return null

    function IsAdminUser() {
        return (
            <>
                {isAllowed(['allowedEdit']) && (
                    <>
                        {!noItineraries ? (
                            <BottomPageFab
                                id="editButton"
                                disabled={!isConnectivityAvailable.value}
                                onClick={() => {
                                    bs().setPast(false)
                                    pushPath('/edit')
                                }}
                                icon={'Edit'}
                                highlight={selectedItinEmpty && !past}
                            />
                        ) : (
                            checkClaimsWeb(['/'], ['createItinerary']) && (
                                // isAllowed(['allowedEdit']) &&
                                // noItineraries &&

                                <BottomPageFab
                                    id="addButton"
                                    onClick={() => {
                                        bs().setPast(false)
                                        pushPath(Paths.newItinerary)
                                    }}
                                    icon={'Add'}
                                    highlight={selectedItinEmpty && !past}
                                />
                            )
                        )}
                    </>
                )}
            </>
        )
    }
    function IsNotAdminUser() {
        return (
            <>
                {isAllowed(['allowedEdit']) && (
                    <>
                        {!noItineraries
                            ? (checkClaimsWeb(['/'], ['createItinerary']) ||
                                  checkClaimsWeb(['/'], ['editItinerary'])) && (
                                  <BottomPageFab
                                      id="editButton"
                                      onClick={() => {
                                          bs().setPast(false)
                                          pushPath('/edit')
                                      }}
                                      icon="Edit"
                                      highlight={selectedItinEmpty && !past}
                                  />
                              )
                            : checkClaimsWeb(['/'], ['createItinerary']) && (
                                  // isAllowed(['allowedEdit']) &&
                                  // noItineraries &&
                                  <BottomPageFab
                                      id="addButton"
                                      onClick={() => {
                                          bs().setPast(false)
                                          pushPath(Paths.newItinerary)
                                      }}
                                      icon="Add"
                                  />
                              )}
                    </>
                )}
            </>
        )
    }
    return (
        <>
            <div style={{ zIndex: 100, position: 'fixed' }}>
                {isAllowed(['checkAdmin']) ? (
                    <IsAdminUser />
                ) : (
                    <IsNotAdminUser />
                )}
            </div>
        </>
    )
}
